import React, {useEffect} from 'react';

import "./OptionMenu.scss";

const OptionMenu = ({
        closeOptionMenu,
        openProofModal,
        edit
  }) => {

  useEffect(() => {

    const checkElement = (event) => {
      const currentElement = event.target;
      const optionMenu  = document.querySelector(".option-menu");

      if(!optionMenu?.contains(currentElement)) {
        closeOptionMenu();
      }
    }

    document.addEventListener('click', (event) => checkElement(event));

    return(
      document.removeEventListener('click', (event) => checkElement(event))
    )
  }, []);

  return (
    <>
      <div className="option-menu">
        <div className="option" onClick={edit}>Edit</div>
        <div className="option_red" onClick={openProofModal}>Delete</div>
      </div>
    </>
  );
};

export default OptionMenu;